import React from "react";
import { Typography, Box, Button } from "@mui/material";
import { useNavigate } from "react-router";
import { NotEligibleForPaymentArrangements } from "../../../SharedComponents/contents";
import { useCustomNavigate } from "../../../Utils/navigationUtils";

interface bsProps {
  onClose: any;
}

function PrepayAccount({ onClose }: bsProps) {
  const notEligibleForPaymentArrangements : any = NotEligibleForPaymentArrangements();
  const JSONcontent : any = notEligibleForPaymentArrangements?.entry;
  const navigate = useNavigate();
  const { customNavigate } = useCustomNavigate();
  const prePayAccount = JSONcontent?.prePayAccount;

  return (
    <Box className="nonAuthEligibleModalBox">
      <Typography className="nonAuthEligibleModalTitle" component="h2" id="scroll-dialog-title">
        {prePayAccount?.title}
      </Typography>
      <Typography className="nonAuthEligibleModalDescription">
        {prePayAccount?.desc}
      </Typography>

      <Box className="buttonBoxContainer">
        <Button
          variant="outlined"
          color="primary"
          onClick={() => onClose()}
          className="secondary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
        >
          {prePayAccount?.closeButton}
        </Button>
        <Button
          variant="contained"
          color="primary"
          className="primary nonAuthEligibleBtn"
          sx={{ textTransform: "none" }}
          onClick={() => customNavigate("/login")}
        >
          {prePayAccount?.signInButton}
        </Button>
      </Box>
    </Box>
  );
}

export default PrepayAccount;
